














import GoogleMapsApiLoader from 'google-maps-api-loader';
import Vue from 'vue';
import VatsGoogleMapEvents from './VatsGoogleMapsEvents';
import html2canvas from 'html2canvas';
import VatsAPI from '../VatsAPI';
import Marker = google.maps.Marker;
import {position} from 'html2canvas/dist/types/css/property-descriptors/position';
import LatLngLiteral = google.maps.LatLngLiteral;
import LatLng = google.maps.LatLng;

const VatsGoogleMap = Vue.extend({
    name: 'VatsGoogleMap',
    props: {
        mapOptions: {
            type: Object as () => google.maps.MapOptions
        },
        initialGeography: {
            type: Object as () => google.maps.PolygonOptions
        },
        heatmapData: {
            type: Array as () => google.maps.LatLngLiteral[]
        },
        markers: {
            type: Array as () => google.maps.Marker[]
        },
        location: {
            type: String
        },
        exportText: {
            type: String
        }
    },
    watch: {
        mapOptions(val: google.maps.MapOptions) {
            if (val && val.center) {
                this.initMap();
            }
        },
        initialGeography(val: google.maps.PolygonOptions) {
            if (!val || !val.paths) {
                this.clearPolygon();
            } else {
                this.loadPolygon(val);
            }
        },
        heatmapData(val: google.maps.LatLngLiteral[]) {
            this.initHeatmap();
        },
        markers(newMarkers: google.maps.Marker[], oldMarkers: google.maps.Marker[]) {
            if (this.map && this.map.getCenter) {
                this.initMarkers(newMarkers, oldMarkers);
            }
        }
    },
    mounted() {
        if (this.mapOptions && this.mapOptions.center) {
            this.initMap();
        }
    },
    data() {
        return {
            apiKey: 'AIzaSyCxUpByStObuiRuZrNP7-S2u7wNQM-PoEQ',
            map: {} as google.maps.Map,
            drawingManager: {} as google.maps.drawing.DrawingManager,
            currentGeography: {} as google.maps.Polygon,
            loading: false,
            polylines: [] as google.maps.Polyline[]
        };
    },
    methods: {
        setCenter(center: LatLng | LatLngLiteral) {
            this.map.setCenter(center);
        },
        addPolyline(line: google.maps.Polyline) {
            line.setMap(this.map);
            this.polylines.push(line);
        },
        addPolylines(lines: google.maps.Polyline[]) {
            lines.forEach(ln => this.addPolyline(ln));
        },
        clearPolylines() {
            this.polylines.forEach(ln => ln.setMap(null));
        },

        async initMap() {
            const googleMapApi = await GoogleMapsApiLoader({
                libraries: ['drawing', 'geometry', 'visualization'],
                apiKey: this.apiKey
            });

            const mapContainer = this.$refs.googleMap;
            this.map = new googleMapApi.maps.Map(mapContainer, this.mapOptions);

            if (this.initialGeography) {
                this.initDrawing();
            }

            if (this.heatmapData && this.heatmapData.length) {
                this.initHeatmap();
            }

            if (this.markers && this.markers.length) {
                this.initMarkers(this.markers, []);
            }
        },
        initDrawing() {
            // drawing
            const drawingManager = new google.maps.drawing.DrawingManager({
                drawingControlOptions: {
                    drawingModes: [google.maps.drawing.OverlayType.POLYGON]
                },
                polygonOptions: {
                    editable: true,
                    draggable: true
                }
            });

            drawingManager.setMap(this.map);

            this.drawingManager = drawingManager;

            google.maps.event.addListener(
                this.drawingManager,
                'polygoncomplete',
                this.polygonComplete
            );
        },
        initHeatmap() {
            if (this.heatmapData && this.heatmapData.length) {
                const heatmap = new google.maps.visualization.HeatmapLayer({
                    data: this.heatmapData.map(
                        item => new google.maps.LatLng(item.lat, item.lng)
                    )
                });

                heatmap.setMap(this.map);

                const latlng = heatmap.getData().getAt(0) as google.maps.LatLng;
                this.map.panTo(latlng);
            }
        },
        initMarkers(newMarkers: google.maps.Marker[], oldMarkers: google.maps.Marker[]) {
            if (oldMarkers && oldMarkers.length) {
                // remove the old markers
                oldMarkers.forEach(m => m.setMap(null));
            }

            if (newMarkers && newMarkers.length) {
                // add the new markers
                newMarkers.forEach(m => m.setMap(this.map));
            }
        },
        setPolygonEvents(polygon: google.maps.Polygon) {
            polygon.getPaths().forEach(path => {
                google.maps.event.addListener(path, 'insert_at', this.polygonEdited);

                google.maps.event.addListener(path, 'remove_at', this.polygonEdited);

                google.maps.event.addListener(path, 'set_at', this.polygonEdited);
            });
            google.maps.event.addListener(polygon, 'dragged', this.polygonEdited);
        },
        loadPolygon(opts: google.maps.PolygonOptions) {
            this.clearPolygon();

            const polygon = new google.maps.Polygon(opts);
            this.currentGeography = polygon;

            this.currentGeography.setMap(this.map);

            this.setPolygonEvents(this.currentGeography);

            this.panToPolygon(this.currentGeography);

            this.$emit(VatsGoogleMapEvents.PolygonLoaded, this.currentGeography);
            this.$emit(VatsGoogleMapEvents.PolygonChanged, this.currentGeography);
        },
        clearPolygon() {
            if (this.currentGeography && this.currentGeography.setMap) {
                this.currentGeography.unbindAll();
                this.currentGeography.setMap(null);
            }

            this.$emit(VatsGoogleMapEvents.PolygonCleared);
            this.$emit(VatsGoogleMapEvents.PolygonChanged, null);
        },
        polygonEdited() {
            this.$emit(VatsGoogleMapEvents.PolygonEdited, this.currentGeography);
            this.$emit(VatsGoogleMapEvents.PolygonChanged, this.currentGeography);
        },
        polygonComplete(polygon: google.maps.Polygon) {
            this.clearPolygon();
            this.currentGeography = polygon;

            this.setPolygonEvents(this.currentGeography);

            this.$emit(VatsGoogleMapEvents.PolygonComplete, this.currentGeography);
            this.$emit(VatsGoogleMapEvents.PolygonChanged, this.currentGeography);
        },
        panToPolygon(polygon: google.maps.Polygon) {
            const bounds = new google.maps.LatLngBounds();

            polygon
                .getPaths()
                .forEach(path => path.forEach(latlng => bounds.extend(latlng)));

            this.map.panToBounds(bounds);
        },
        async generateImage() {
            const canvas = await html2canvas(
                document.querySelector('#vats-google-map-container') as HTMLElement,
                {
                    useCORS: true
                }
            );

            const dataUrl = canvas.toDataURL();
            return dataUrl;
        },
        async exportImage() {
            const dataUrl = await this.generateImage();

            this.$emit('imageExported', dataUrl);
        },
        async downloadImage() {
            this.loading = true;
            try {
                const dataUrl = await this.generateImage();

                const downloadBase64File = (contentBase64: string, fileName: string) => {
                    const downloadLink = document.createElement('a');
                    document.body.appendChild(downloadLink);

                    downloadLink.href = contentBase64;
                    downloadLink.target = '_self';
                    downloadLink.download = fileName;
                    downloadLink.click();
                };

                downloadBase64File(dataUrl, 'lpr-analysis.png');
            } catch (e) {
                throw e;
            } finally {
                this.loading = false;
            }
        }
    }
});

export default VatsGoogleMap;
